import React, { useCallback } from 'react';

import {
    className,
    Heading,
    Text,
    ImageComponent,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import VideoComponent from 'aplazame-design-system/src/components/VideoComponent';
import style from './style.module.scss';

function ClientStoryAuthor({ image, name, personPosition, wrapperClassName }) {
    return (
        <div
            {...className(
                `d-flex justify-content-start mb-4 align-items-center ${
                    wrapperClassName ? wrapperClassName : ''
                }`
            )}
        >
            <div {...className(style['author-image-wrapper'])}>
                {image && image.file && image.file.childImageSharp ? (
                    <img
                        {...className(style['author-image'])}
                        src={image.file.childImageSharp.resize.src}
                        alt={name}
                    />
                ) : null}
            </div>
            <div>
                <Text tag="p" className="body font-weight-bold">
                    {name}
                </Text>
                <Text tag="p" className="body">
                    {personPosition}
                </Text>
            </div>
        </div>
    );
}

export default function CardClientStoryComponent({
    video,
    image,
    detachedImage,
    title,
    client,
    author,
    ctaText,
    ctaUrl,
    text,
    youtubeId,
    detached,
    noPadding,
}) {
    const openVideo = useCallback(
        (e) => {
            if (youtubeId) {
                if (e) {
                    e.preventDefault();
                }

                window.location.hash = `?v=${youtubeId}`;
            }
        },
        [youtubeId]
    );

    let element = video?.url ? (
        <VideoComponent url={video.url} play={true} />
    ) : (
        <div onClick={openVideo}>
            <ImageComponent
                image={image}
                className={`${youtubeId ? style['image--with-video'] : ''} ${
                    detached ? 'd-lg-none' : ''
                } ${detached ? style.imageDetached : ''}`}
            />
        </div>
    );

    return (
        <div
            {...className(
                `${
                    style.wrapper
                } d-lg-flex flex-lg-column justify-content-lg-between ${
                    detached
                        ? style['wrapper--detached']
                        : noPadding
                        ? ''
                        : 'pl-lg-2 pr-lg-2 pl-xl-5 pr-xl-5'
                }`
            )}
        >
            <div className={style.wrapperImage}>
                {element}
                <div
                    {...className(
                        `${detached ? `bg-white pl-5 pr-5 pt-5` : 'pt-3'}`
                    )}
                >
                    <div
                        {...className(
                            `${style['logo-wrapper']} mb-${detached ? 1 : 2}`
                        )}
                    >
                        {client &&
                        client.logoBlack &&
                        client.logoBlack.file &&
                        client.logoBlack.file.childImageSharp ? (
                            <img
                                {...className(
                                    `${style.logo} ${
                                        detached ? style['logo--detached'] : ''
                                    }`
                                )}
                                src={
                                    client.logoBlack.file.childImageSharp.resize
                                        .src
                                }
                                alt={client.title}
                            />
                        ) : null}
                    </div>
                    <Heading
                        tag="h4"
                        className={`${style.heading}`}
                        pb={{ xs: detached ? 3 : 2 }}
                    >
                        {title}
                    </Heading>
                    {detached && text ? (
                        <Text tag="p" className="body">
                            {text}
                        </Text>
                    ) : null}
                </div>
            </div>
            <div {...className(detached ? 'bg-white pl-5 pr-5 pb-5 pt-3' : '')}>
                {author ? (
                    <ClientStoryAuthor
                        {...author}
                        wrapperClassName={detached ? 'mb-lg-7' : ''}
                    />
                ) : null}
                <div
                    className={style.wrapperButton}
                    style={{ visibility: ctaUrl ? 'visible' : 'hidden' }}
                >
                    <ButtonComponent
                        blockMobile={detached ? true : false}
                        button={{
                            detached: true,
                            externalLink: youtubeId
                                ? `#?v=${youtubeId}`
                                : ctaUrl,
                            label: ctaText,
                            block: detached ? false : true,
                            target: youtubeId ? '_self' : '_blank',
                        }}
                    />
                </div>
            </div>
            {detachedImage &&
            detachedImage.file &&
            detachedImage.file.childImageSharp ? (
                <div
                    {...className(
                        `${style['image-detached']} d-none d-lg-block ${
                            youtubeId ? style['image--with-video'] : ''
                        }`
                    )}
                    onClick={openVideo}
                    style={{
                        backgroundImage: `url(${detachedImage.file.childImageSharp.resize.src})`,
                    }}
                />
            ) : null}
        </div>
    );
}
